export const UserManagementTab = {
    CUSTOMER: "CUSTOMERS",
    VF_GROUP_USER: "VF_GROUP_USER",
    ON_BOARDING_APPROVALS: "ON_BOARDING_APPROVALS",
    // MY_REQUEST: "MY_REQUEST",
    ON_BOARDING_REQUEST: "ON_BOARDING_REQUEST", 
}

export const ServiceType = {
    International_Voice_Services: "International_Voice_Services",
    IPX_Services: "IPX_Services",   
}
export const My_Request_SUBTAB = {
    ON_BOARDING_REQUEST: "ON_BOARDING_REQUEST",
    EXTENSION_ACCESS_REQUEST: "EXTENSION_ACCESS_REQUEST",
    EXTENSION_ACCESS_APPROVAL: "EXTENSION_ACCESS_APPROVAL",
    ON_BOARDING_APPROVAL: "ON_BOARDING_APPROVAL",
}

export const EXTENSTION_STATUS = {
    PENDING : "pending",
    APPROVED : "approved"
}

export const ON_BOARDING_STATUS = {
    PENDING : "pending",
    APPROVED : "approved",
    REJECTED : "rejected"
}

export const FUNCTIONAL_ROLE_ENUM = {
    USER_MANAGEMENT:"user_management_customer",
    INCIDENT_MANAGEMENT:"incident_management_customer",
    DASHBOARD:"dashboard_customer",
    REGULATORY:"regulatory_customer"
}

export const headers = ["Operator Code", "Operator Name"];
export const columnConfig = [{ name: "Operator Code", flex: 1 },{ name: "Operator Name", flex: 2 }];

export const customerListcolumnConfig = [
    { name: 'organisationLegalName', weight: 3 },
    { name: 'serviceType', weight: 3 },
    { name: 'requestor', weight: 3 },
    { name: 'lastModifiedNo', weight: 3 },
    { name: 'user', weight: 2 }
  ];

export const customerDetailcolumnConfig = [
    { name: 'contactName', weight: 3 },
    { name: 'emailAddress', weight: 3 },
    { name: 'assignedOn', weight: 2 },
    { name: 'status', weight: 1 },
  ];
export const accountmanagerDetailcolumnConfig = [
    { name: 'contactName', weight: 3 },
    { name: 'emailAddress', weight: 3 },
    { name: 'onboardedOn', weight: 2 },
    { name: 'recentActivityTime', weight: 2 },
    { name: 'lastUpdatedOn', weight: 2 },
    { name: 'status', weight: 1 },
    { name: 'editAccess', weight: 1 },
  ];

export const onboardingRequestcolumnConfig = [
    { name: 'requestId', weight: 2 },
    { name: 'organisationLegalName', weight: 4 },
    { name: 'serviceType', weight: 2 },
    { name: 'requestAssignTo', weight: 2 },
    { name: 'requestedOn', weight: 2 },
    { name: 'modifiedOn', weight: 2 },
  ];

export const onboardingApprovalcolumnConfig = [
    { name: 'requestId', weight: 2 },
    { name: 'organisationLegalName', weight: 4 },
    { name: 'serviceType', weight: 2 },
    { name: 'requestedOn', weight: 2 },
    { name: 'modifiedOn', weight: 2 },
  ];
  export const vFUserscolumnConfig = [
    { name: 'userName',  weight: 3 },
    { name: 'emailAddress',  weight: 2 },
    { name: 'role', weight: 2 },
    { name: 'createdOn',  weight: 2},
    { name: 'recentLoginTime',  weight: 2},
    { name: 'lastUpdatedOn', weight: 2},
    { name: 'status',  weight: 1},
    { name: 'editAccess',  weight: 1},
  ];

export const serviceType = [{label:"IPX Service", value:"ipx_service"},{label:"International Voice Service", value:"ivc_service"}]

export const subTabs = {
  customers: "CUSTOMERS",
  onboardingRequests: "ON_BOARDING_REQUEST",
  onboardingApprovals: "ON_BOARDING_APPROVALS",
  vodafoneUsers: "VF_GROUP_USER",
};
export const adminEmail = "sajukumarnair.sukumarannair@vodafone.com"

export const FILTER_KEYS = {
  CUSTOMER: "CUSTOMER",
  ONBOARDING: "ONBOARDING",
  ONBOARDINGAPPROVAL:"ONBOARDINGAPPROVAL",
  TICKETS:"TICKETS",
  SERVICEREQUEST:"SERVICEREQUEST",
  LIVESERVICES:"LIVESERVICES",
  DEMANDS:"DEMANDS",
  VFUSER:"VFUSER",
  BROADCAST:"BROADCAST",
  INVOICE:"INVOICE"
};
export const COLUMN_KEYS = {
  ORG_NAME: "orgName",
  TADIG_CODE:"tadigCode",
  SERVICE: "service",
  VF_USER_NAME:"vfUserName",
  ROLE:"role",
  INVOICEDPARTY:"invoicedParty",
  INVOICINGPARTY:"invoicingParty"
};
export const SORT_FIELDS = {
  ORGANISATION_NAME: "displayName",
  LAST_MODIFIED: "modifiedAt",
  USER_NAME: "userName",
  LAST_UPDATEDON: "lastUpdatedOn",
};
export const SORT_ORDER = {
  ASC: "asc",
  DESC: "desc",
};
export const TYPE = {
  ipx_service:"IPX Service",
  ivc_service:"International Voice Service"
}

export const CustomerSortOptions = [
  {
    label: "Organisation Legal Name: A to Z",
    field: SORT_FIELDS.ORGANISATION_NAME,
    order: SORT_ORDER.ASC,
  },
  {
    label: "Organisation Legal Name: Z to A",
    field: SORT_FIELDS.ORGANISATION_NAME,
    order: SORT_ORDER.DESC,
  },
  {
    label: "Last Modified: Oldest First",
    field: SORT_FIELDS.LAST_MODIFIED,
    order: SORT_ORDER.ASC,
  },
  {
    label: "Last Modified: Newest First",
    field: SORT_FIELDS.LAST_MODIFIED,
    order: SORT_ORDER.DESC,
  },
];

export const vfSortOptions = [
  {
    label: "User Name: A to Z",
    field: SORT_FIELDS.USER_NAME,
    order: SORT_ORDER.ASC,
  },
  {
    label: "User Name: Z to A",
    field: SORT_FIELDS.USER_NAME,
    order: SORT_ORDER.DESC,
  },
  {
    label: "Last Updated On: Oldest First",
    field: SORT_FIELDS.LAST_MODIFIED,
    order: SORT_ORDER.ASC,
  },
  {
    label: "Last Updated On: Newest First",
    field: SORT_FIELDS.LAST_MODIFIED,
    order: SORT_ORDER.DESC,
  },
];

export const LIST_TYPE = {
  ACCOUNT_MANAGER_LIST: "accountManagerList",
  CUSTOMER_LIST: "customerList",
};